import { render, staticRenderFns } from "./_responseLogsTable.vue?vue&type=template&id=460a5646"
import script from "./_responseLogsTable.vue?vue&type=script&lang=js"
export * from "./_responseLogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports